// src/pages/Estatisticas/components/ExportarUsoIADialog.js
import React, { useState } from 'react';
import axios from 'axios';

const PERIODOS = [
  { value: 'este_mes', label: 'Este Mês' },
  { value: 'ultimo_mes', label: 'Último Mês' },
  { value: 'ultimos_3_meses', label: 'Últimos 3 Meses' },
  { value: 'tudo', label: 'Tudo' }
];

const formatarNumero = (n) => Number(n).toLocaleString('pt-BR');

const ExportarUsoIADialog = ({ onClose }) => {
  const [periodo, setPeriodo] = useState('este_mes');
  const [custoIn, setCustoIn] = useState('5.00');
  const [custoOut, setCustoOut] = useState('20.00');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [resultados, setResultados] = useState(null);

  const dispararDownload = (dados) => {
    const linhas = [
      ['cod_cliente', 'total_token_in', 'total_token_out', 'valor_total'].join(',')
    ];
    dados.forEach(d => {
      linhas.push([d.codCli, d.totalTokenIn, d.totalTokenOut, d.valorTotal.toFixed(2)].join(','));
    });

    const csvContent = linhas.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const dataAtual = new Date().toISOString().slice(0, 10);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `uso_ia_por_cliente_${periodo}_${dataAtual}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  const handleExportar = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await axios.get('/api/estatisticas/uso-ia-por-cliente/exportar', {
        params: { periodo, custoIn, custoOut }
      });

      if (response.data.success) {
        const dados = response.data.data;
        setResultados(dados);
        dispararDownload(dados);
      } else {
        setError(response.data.message || 'Erro ao exportar dados');
      }
    } catch (err) {
      setError('Erro ao exportar: ' + (err.response?.data?.message || err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="export-dialog-overlay" onClick={onClose}>
      <div className="export-dialog" onClick={e => e.stopPropagation()}>
        <div className="export-dialog-header">
          <h3>Exportar Uso de IA por Cliente</h3>
          <button className="export-dialog-close" onClick={onClose}>×</button>
        </div>

        <div className="export-dialog-body">
          <div className="export-field">
            <label>Período</label>
            <div className="export-period-group">
              {PERIODOS.map(p => (
                <button
                  key={p.value}
                  className={`export-period-btn${periodo === p.value ? ' active' : ''}`}
                  onClick={() => setPeriodo(p.value)}
                  disabled={loading}
                >
                  {p.label}
                </button>
              ))}
            </div>
          </div>

          <div className="export-field-row">
            <div className="export-field">
              <label>Custo Token In (€ / 1M tokens)</label>
              <input
                type="number"
                step="0.01"
                min="0"
                value={custoIn}
                onChange={e => setCustoIn(e.target.value)}
                disabled={loading}
              />
            </div>
            <div className="export-field">
              <label>Custo Token Out (€ / 1M tokens)</label>
              <input
                type="number"
                step="0.01"
                min="0"
                value={custoOut}
                onChange={e => setCustoOut(e.target.value)}
                disabled={loading}
              />
            </div>
          </div>

          <button className="export-btn-principal" onClick={handleExportar} disabled={loading}>
            {loading ? 'A exportar...' : 'EXPORTAR'}
          </button>

          {error && <div className="error-stats" style={{ marginTop: 15 }}>{error}</div>}

          {resultados && (
            <div className="export-resultados">
              <p className="export-resultados-info">
                {resultados.length} {resultados.length === 1 ? 'registro encontrado' : 'registros encontrados'} — ficheiro CSV descarregado.
              </p>

              {resultados.length > 0 && (
                <div className="export-results-table">
                  <div className="export-results-header">
                    <div>Cód. Cliente</div>
                    <div>Total Token In</div>
                    <div>Total Token Out</div>
                    <div>Valor Total</div>
                  </div>
                  {resultados.map((r, i) => (
                    <div key={i} className="export-results-row">
                      <div className="uso-ia-codcli">{r.codCli}</div>
                      <div>{formatarNumero(r.totalTokenIn)}</div>
                      <div>{formatarNumero(r.totalTokenOut)}</div>
                      <div>{r.valorTotal.toFixed(2)} €</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExportarUsoIADialog;
